import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

export function ErrorNote({ message, onRetry, onDismiss }: { message: string; onRetry?: () => void; onDismiss?: () => void }) {
  return (
    <div role="alert" className="flex items-center justify-between gap-3 rounded-lg border border-destructive/50 bg-destructive/10 px-4 py-3 font-ui text-sm">
      <span>{message}</span>
      <span className="flex shrink-0 gap-1">
        {onRetry && (
          <Button size="sm" variant="outline" onClick={onRetry} className="gap-1.5">
            <RefreshCw className="size-3.5" aria-hidden /> Retry
          </Button>
        )}
        {onDismiss && (
          <Button size="sm" variant="ghost" onClick={onDismiss}>
            Dismiss
          </Button>
        )}
      </span>
    </div>
  );
}

export function LoadingLeaf() {
  return (
    <div className="mx-auto max-w-2xl animate-pulse space-y-4 px-5 pt-10 sm:px-8" aria-busy="true" aria-label="Loading the verse">
      <div className="h-3 w-24 rounded bg-secondary" />
      <div className="h-6 w-full rounded bg-secondary" />
      <div className="h-6 w-11/12 rounded bg-secondary" />
      <div className="h-6 w-2/3 rounded bg-secondary" />
    </div>
  );
}
